import { render } from "./recruitmentReport.vue?vue&type=template&id=71616e06&scoped=true"
import script from "./recruitmentReport.vue?vue&type=script&lang=js"
export * from "./recruitmentReport.vue?vue&type=script&lang=js"

import "./recruitmentReport.vue?vue&type=style&index=0&id=71616e06&scoped=true&lang=css"
import "./recruitmentReport.vue?vue&type=style&index=1&id=71616e06&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71616e06"]])

export default __exports__